import moment from 'moment';

import { CV_PREFIX } from '@app/components/Calendars/components/CalendarView/constants';
import { Day } from '@app/components/Calendars/components/MonthGrid/components/Day';
import type { NCalendars } from '@app/components/Calendars/types';

import '@app/components/Calendars/components/MonthGrid/styles/Week.desktop.scss';

const { Grid, Header, TaskList } = Day;

export const Week: NCalendars.Week = ({ days, year, month, isBottomWeek }) => (
  <div className={`${CV_PREFIX}-row`}>
    <div className={`${CV_PREFIX}-grids`}>
      {days.map(({ id }) => (
        <Grid key={id} id={id} />
      ))}
    </div>
    <div className={`${CV_PREFIX}-headers`}>
      {days.map(({ id, ...props }) => (
        <Header key={id} id={id} {...props} month={month} year={year} />
      ))}
    </div>
    <div className={`${CV_PREFIX}-task-lists`}>
      {days.map(({ id, ...props }) => {
        const currentDate = moment(id, 'YYYY-M-D');
        const currentDay = currentDate.date();
        const currentMonth = currentDate.month() + 1;
        const currentYear = currentDate.year();
        return (
          <TaskList
            key={id}
            id={id}
            {...props}
            month={currentMonth}
            year={currentYear}
            day={currentDay}
            isBottomWeek={isBottomWeek}
          />
        );
      })}
    </div>
  </div>
);
